"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Swatches = function Swatches(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#000' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="44" height="42"' : 'width="100%"';
  var title = 'Swatches Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" ").concat(iconSize, " viewBox=\"0 0 44 42\">\n      <title>").concat(title, "</title>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.35086 34.3875L7.74067 35.3675V19.565L3.40692 29.82C2.67571 31.605 3.54959 33.6525 5.35086 34.3875ZM40.1279 27.9125L31.282 6.965C30.7292 5.6525 29.4273 4.8475 28.054 4.8125C27.5903 4.8125 27.1088 4.8825 26.6451 5.075L13.5012 10.4125C12.1636 10.955 11.3432 12.215 11.3075 13.5625C11.2897 14.035 11.3789 14.5075 11.5751 14.9625L20.4209 35.91C20.9738 37.24 22.2935 38.045 23.6846 38.0625C24.1483 38.0625 24.612 37.975 25.0578 37.8L38.1839 32.4625C40.003 31.7275 40.8769 29.68 40.1279 27.9125ZM14.8922 15.3125C13.9114 15.3125 13.1088 14.525 13.1088 13.5625C13.1088 12.6 13.9114 11.8125 14.8922 11.8125C15.8731 11.8125 16.6757 12.6 16.6757 13.5625C16.6757 14.525 15.8731 15.3125 14.8922 15.3125ZM11.3254 34.5625C11.3254 36.4875 12.9305 38.0625 14.8922 38.0625H17.4782L11.3254 23.4675V34.5625Z\" fill=\"").concat(color, "\" />\n    </svg>\n  ");
};

var _default = Swatches;
exports["default"] = _default;